// Central logging utility. All console output in the app should go through
// this module instead of calling `console.*` directly, so logs can be
// silenced in production builds from a single place.
//
// Usage:
//   import logger from "../../Utils/logger";
//   logger.log("cart", items);
//
// Importing this module also patches the global `console`, so direct
// `console.*` calls from libraries (e.g. React's "Warning: ..." messages)
// follow the same rules. It is imported first in src/index.js.
const isProd = process.env.NODE_ENV === "production";

const noop = () => {};

// Keep the real console methods before patching the global one.
const original = {
  info: console.info.bind(console),
  error: console.error.bind(console),
  debug: console.debug.bind(console),
  log: console.log.bind(console),
  warn: console.warn.bind(console),
};

// React (and other libraries) report dev warnings through console.error
// with a "Warning:" prefix; treat those as warnings and drop them.
const isLibraryWarning = (first) =>
  typeof first === "string" && first.startsWith("Warning:");

const error = isProd
  ? noop
  : (...args) => {
      if (isLibraryWarning(args[0])) return;
      original.error(...args);
    };

const logger = {
  // log and warn are silenced everywhere (dev and prod).
  log: noop,
  warn: noop,
  info: isProd ? noop : original.info,
  error,
  debug: isProd ? noop : original.debug,
};

console.log = logger.log;
console.warn = logger.warn;
console.info = logger.info;
console.error = logger.error;
console.debug = logger.debug;

export default logger;
